import { Link, useNavigate } from 'react-router-dom';
import { Container, Col } from 'reactstrap';
import { Btn, H3, P } from '../../../AbstractElements';
import { BACK_TO_HOME_PAGE } from '../../../Constant';
import { Error4 } from '../../../Data/svgIcons';
import { firebaseAuth } from '../../../firebase/init';

const ErrorPage4 = ({ coordination, setPageAllow }) => {
    const navigate = useNavigate()

    const logout = async () => {
        await firebaseAuth.signOut()
        navigate(`${process.env.PUBLIC_URL}/login`);
        localStorage.removeItem('admin_login')
        localStorage.removeItem('refresh_tracked')
    }

    return (
        <div className="page-wrapper" id="pageWrapper">
            <div className="error-wrapper">
                <Container>
                    <div className="error-page1">
                        <div className="svg-wrraper">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                data-name="Layer 1"
                                width="773.09925"
                                height={600}
                                viewBox="0 0 773.09925 600"
                                xmlnsXlink="http://www.w3.org/1999/xlink"
                            >
                                <path
                                    d="M225.34292,702.60436c5.05211,17.52641,19.80364,29.79509,35.19135,40.21717q3.22281,2.18325,6.44766,4.266c.01457.00637.02957.02.04432.02649.10343.06645.20707.133.30345.19991.44371.286.88758.57223,1.32761.85495l-.24171.10858s-.23734.12621.02233.02024c.07728-.03233.15825-.06136.23537-.09387,8.93929-3.60536,18.03735-7.4764,24.888-14.23042,7.10651-7.0136,11.25952-18.01412,7.41141-27.228a17.5918,17.5918,0,0,0-1.90481-3.41886c-.31214-.44666-.64831-.87416-.99832-1.29373a18.85591,18.85591,0,0,0-32.3856,5.72979c-1.1305-10.52575,7.54879-19.34265,15.90135-25.84822,8.35623-6.50228,17.85126-13.58341,19.46674-24.05073.90215-5.82389-1.12306-11.46779-4.81223-15.99853-.11422-.13766-.22828-.27513-.34591-.409a27.51849,27.51849,0,0,0-17.68718-9.48885c-12.81321-1.33167-25.25927,5.4506-34.56778,14.35941C228.65693,660.66042,219.59966,682.67693,225.34292,702.60436Z"
                                    transform="translate(-213.45038 -150)"
                                    fill="#f1f1f1"
                                />
                                <path
                                    d="M249.42712,679.68a46.77976,46.77976,0,0,0-5.60443,12.36092,40.61933,40.61933,0,0,0-1.404,11.9968,52.04362,52.04362,0,0,0,6.81623,23.68461,74.90284,74.90284,0,0,0,11.29937,15.09919q3.22281,2.18325,6.44766,4.266c.01457.00637.02957.02.04432.02649.10343.06645.20707.133.30345.19991.44371.286.88758.57223,1.32761.85495,0,0-.479.23479-.21938.12882.07728-.03233.15825-.06136.23537-.09387a41.40487,41.40487,0,0,1,13.249-35.6508,41.75957,41.75957,0,0,1,17.14558-9.22645c-.31214-.44666-.64831-.87416-.99832-1.29373a43.29621,43.29621,0,0,0-7.14663,2.70436,42.424,42.424,0,0,0-19.1818,18.49347,43.37374,43.37374,0,0,0-4.72252,23.80133c-.3673-.33284-.735-.67291-1.09168-1.00976-6.79289-6.33309-12.82634-13.60244-16.90958-21.99188a48.41654,48.41654,0,0,1-5.06985-22.90746c.33325-8.65329,3.781-16.66846,8.77295-23.64613a101.345,101.345,0,0,1,19.2105-19.79843,115.15818,115.15818,0,0,1,23.89219-14.75057.828.828,0,0,0,.41668-1.06262.70421.70421,0,0,0-.34591-.409.613.613,0,0,0-.53243.02262c-1.0539.48517-2.10048.977-3.13867,1.49006a116.46492,116.46492,0,0,0-24.06247,15.87266C261.07753,664.88005,254.40949,671.77906,249.42712,679.68Z"
                                    transform="translate(-213.45038 -150)"
                                    fill="#fff"
                                />
                                <polygon
                                    points="238.265 584.987 251.69 584.987 258.076 533.207 238.263 533.208 238.265 584.987"
                                    fill="#ffb7b7"
                                />
                                <path
                                    d="M448.29143,730.60424l26.43742-.00107h.00107a16.84892,16.84892,0,0,1,16.848,16.84773v.5475L448.29223,748Z"
                                    transform="translate(-213.45038 -150)"
                                    fill="#2f2e41"
                                />
                                <polygon
                                    points="165.581 584.987 179.006 584.987 185.392 533.207 165.579 533.208 165.581 584.987"
                                    fill="#ffb7b7"
                                />
                                <path
                                    d="M375.60734,730.60424l26.43742-.00107h.00107a16.84891,16.84891,0,0,1,16.848,16.84773v.5475L375.60814,748Z"
                                    transform="translate(-213.45038 -150)"
                                    fill="#2f2e41"
                                />
                                <polygon
                                    points="160.112 350.309 160.112 487.025 163.573 575.284 192.127 575.284 201.646 409.149 220.682 477.507 232.796 573.553 267.407 571.823 244.045 350.309 160.112 350.309"
                                    fill="#2f2e41"
                                />
                                <circle cx="193.30584" cy="206.67144" r="20.76688" fill="#ffb8b8" />
                                <polygon
                                    points="184.677 232.849 179.148 238.687 173.956 355.501 235.392 353.771 220.682 251.667 207.703 239.229 201.117 232.849 184.677 232.849"
                                    fill="#6c63ff"
                                />
                                <path
                                    d="M388.27186,395.60934l4.66336-7.56867,1.39364,16.22154s11.24873,36.34205,10.38345,68.35766,4.32643,107.29554-2.59587,108.16083-36.342,2.59586-36.342-3.46115-1.73058-167.00036-1.73058-167.00036Z"
                                    transform="translate(-213.45038 -150)"
                                    fill="#2f2e41"
                                />
                                <path
                                    d="M419.75911,388.04067l11.77709,9.29924,25.9586,9.51816s0,110.75669,5.19172,136.7153,14.70988,28.55446,2.59587,29.41975-11.24873-3.46115-11.24873-3.46115S418.5569,458.77525,420.28747,431.08608,418.02853,388.04067,419.75911,388.04067Z"
                                    transform="translate(-213.45038 -150)"
                                    fill="#2f2e41"
                                />
                                <path
                                    d="M387.10956,363.16869s1.76443-3.09861,1.35423-13.45,15.35253-4.49678,28.52394-5.48425S427.371,361.51636,427.371,361.51636s.95024-1.086,2.98468-9.90338-2.58483-17.6042-2.58483-17.6042c-1.36045-9.2654-8.69232-6.29583-8.69232-6.29583,3.53094,1.37456,2.85278,4.31368,2.85278,4.31368-2.98882-5.24021-10.32069-2.27064-10.32069-2.27064-9.7786-6.13631-19.6891,1.94444-19.6891,1.94444-11.813,2.681-4.88515,12.07543-4.88515,12.07543C375.15634,349.7795,387.10956,363.16869,387.10956,363.16869Z"
                                    transform="translate(-213.45038 -150)"
                                    fill="#2f2e41"
                                />
                                <path
                                    d="M365.80342,564.80782a8.76008,8.76008,0,0,0-1.55337-13.34245l3.74089-19.66571-11.39633-5.1881-4.89281,27.846a8.80758,8.80758,0,0,0,14.10162,10.35028Z"
                                    transform="translate(-213.45038 -150)"
                                    fill="#ffb7b7"
                                />
                                <path
                                    d="M368.37026,410.31922l-2.29755-1.23184s-12.41233,4.693-11.547,8.15413-6.9223,124.60128-4.32644,128.92772,23.36275.86528,23.36275.86528Z"
                                    transform="translate(-213.45038 -150)"
                                    fill="#2f2e41"
                                />
                                <path
                                    d="M467.15028,556.652a8.76014,8.76014,0,0,1-.30766-13.429l-6.42588-18.959,10.56888-6.715,8.69856,26.90117a8.80758,8.80758,0,0,1-12.5339,12.20185Z"
                                    transform="translate(-213.45038 -150)"
                                    fill="#ffb7b7"
                                />
                                <path
                                    d="M457.0072,540.1231s21.046.55452,23.01832-4.08947S457.524,412.49216,457.90206,408.94458s-12.5642-6.478-12.5642-6.478l-2.105,1.53787Z"
                                    transform="translate(-213.45038 -150)"
                                    fill="#2f2e41"
                                />
                                <path
                                    d="M595.45038,750h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z"
                                    transform="translate(-213.45038 -150)"
                                    fill="#cbcbcb"
                                />
                                <path
                                    d="M986.54962,458H634.89152V239.06926h351.6581Zm-343.47595-8.18215H978.36748V247.2514H643.07367Z"
                                    transform="translate(-213.45038 -150)"
                                    fill="#e5e5e5"
                                />
                                <rect
                                    x="425.53215"
                                    y="93.16049"
                                    width="343.476"
                                    height="210.74826"
                                    fill="#fff"
                                />
                                <path
                                    d="M982.45855,296.5736V283.63369H934.81073V243.16048h-12.94v40.47321H837.04247V243.16048h-12.94v40.47321H693.26562V243.16048h-12.94v40.47321h-41.343V296.5736h41.343v50.322h-41.343v12.93992h41.343v53.91637h-41.343v12.93991h111.075v27.217h12.93962v-27.217h61.10521v27.217h12.94v-27.217H982.45855V413.75184H837.04247V359.83547H982.45855V346.89555H934.81073v-50.322Zm-158.35609,0v15.81546H693.26562V296.5736ZM693.26562,325.329H824.10246v21.56658H693.26562Zm0,88.42287V359.83547h56.792v53.91637Zm130.83684,0H762.99725V359.83547h61.10521Zm97.76826-66.85629H837.04247v-50.322h84.82825Z"
                                    transform="translate(-213.45038 -150)"
                                    fill="#e6e6e6"
                                />
                                <path
                                    d="M892.9978,212.0474c0,34.26782-62.0474,110.60623-62.0474,110.60623S768.903,246.31522,768.903,212.0474a62.0474,62.0474,0,0,1,124.0948,0Z"
                                    transform="translate(-213.45038 -150)"
                                    fill="#6c63ff"
                                />
                                <path
                                    d="M859.31567,209.34968a28.36454,28.36454,0,1,1-28.36454-28.36454A28.35155,28.35155,0,0,1,859.31567,209.34968Z"
                                    transform="translate(-213.45038 -150)"
                                    fill="#fff"
                                    style={{ isolation: "isolate" }}
                                />
                                <circle cx="617.50002" cy="200.70983" r="16.72582" fill="#6c63ff" />
                            </svg>

                        </div>
                        <Col md="8" className="offset-md-2">
                            <H3>400 - Access Denied</H3>
                            {coordination ?
                                <Btn attrBtn={{
                                    className: 'btn-lg', color: 'primary', onClick: () => {
                                        setPageAllow(true)
                                        navigate("/dashboard")
                                    }
                                }}>
                                    Navigate to Dashboard</Btn>
                                : <Btn attrBtn={{ className: 'btn-lg', color: 'primary', onClick: logout }}>
                                    Logout</Btn>
                            }
                            {/* <Link to={`${process.env.PUBLIC_URL}/dashboard/default`}> */}
                            {/* </Link> */}
                        </Col>
                    </div>
                </Container>
            </div>
        </div>
    );
};

export default ErrorPage4;